// Constants
import { PERCENT_MAX } from '../constants/ui';

const GRID_COLUMNS_COUNT = 12;

const getGridPropValues =
  (isTabletMode, isMobileMode) =>
  ({ lgSize, mdSize, unit }) => {
    if (lgSize && isTabletMode && !isMobileMode) {
      return unit
        ? `${(lgSize * PERCENT_MAX) / GRID_COLUMNS_COUNT}${unit}`
        : lgSize;
    }

    if (mdSize && isMobileMode) {
      return unit
        ? `${(mdSize * PERCENT_MAX) / GRID_COLUMNS_COUNT}${unit}`
        : mdSize;
    }

    if (!mdSize && isMobileMode) {
      return 'initial';
    }
  };

export default getGridPropValues;
